import { styled } from '@mui/material';

export const Divider = styled('div')(() => ({
    width: '1px',
    height: '124px',
    backgroundColor: '#d6d6d6',
}));
